import { emitDocumentPreviewOpenRequested } from '@/features/documentPreview/documentPreviewEvents'
import { detectGeneratedArtifactKind } from '@/utils/generatedArtifactAssistantPayloadBody.js'
import { resolveGeneratedArtifactDetails } from '@/utils/generatedArtifactAssistantPayloadResolve.js'
import { buildGeneratedArtifactAssistantMessagePatch } from '@/utils/generatedArtifactAssistantPayloadPatch.js'
import { scaleChatStreamDelay } from '../streaming/chatStreamSpeed.js'

/** @param {import('./runResponseComponentDemoStream.js').DemoStreamCtx & { trimmed: string }} ctx */
export function runGeneratedArtifactTurn(ctx) {
  const { tid, pendingId, trimmed, signal, session, setMessagesByThreadId } = ctx

  session.addTimeout(() => {
    if (signal.aborted) {
      session.dispose()
      return
    }
    const kind = detectGeneratedArtifactKind(trimmed)
    if (!kind) {
      session.dispose()
      return
    }
    const details = resolveGeneratedArtifactDetails(trimmed, kind)
    let artifactId = ''

    setMessagesByThreadId((inner) => {
      const list = [...(inner[tid] ?? [])]
      const idx = list.findIndex((m) => m.id === pendingId)
      if (idx === -1) return inner
      const next = [...list]
      const prev = list[idx]
      const started =
        typeof prev.thinkingStartedAt === 'number' ? prev.thinkingStartedAt : prev.createdAt
      const { patch, artifactId: id } = buildGeneratedArtifactAssistantMessagePatch(trimmed, started)
      artifactId = id
      next[idx] = { ...next[idx], ...patch }
      return { ...inner, [tid]: next }
    })

    if (artifactId) {
      emitDocumentPreviewOpenRequested({
        artifactId,
        kind: details.kind,
        fileName: details.fileName,
        description: details.description,
      })
    }

    session.dispose()
  }, scaleChatStreamDelay(500))
}
